import { render, staticRenderFns } from "./HomePageUpdateBanner.vue?vue&type=template&id=5a5b7f41&scoped=true"
import script from "./HomePageUpdateBanner.vue?vue&type=script&lang=js"
export * from "./HomePageUpdateBanner.vue?vue&type=script&lang=js"
import style0 from "./HomePageUpdateBanner.vue?vue&type=style&index=0&id=5a5b7f41&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5b7f41",
  null
  
)

export default component.exports